// In-memory storage (cleared on page refresh/close)
let accessToken = null;

let _resolve = null;
let _tokenReadyPromise = new Promise((resolve) => {
    _resolve = resolve;
});

function resetTokenReadyPromise() {
    _tokenReadyPromise = new Promise((resolve) => {
        _resolve = resolve;
    });
}

export const tokenStorage = {
    /**
     * Set access token in memory
     * @param {string} token - JWT access token
     */
    set(token) {
        accessToken = token;
        if (_resolve) {
            _resolve(token);
            _resolve = null;
        }
    },

    /**
     * Get access token from memory
     * @returns {string|null} - JWT access token or null
     */
    get() {
        return accessToken;
    },

    /**
     * Resolves with the current token immediately if set, otherwise when set() is first called.
     * @returns {Promise<string>}
     */
    waitForToken() {
        return accessToken ? Promise.resolve(accessToken) : _tokenReadyPromise;
    },

    /**
     * Remove access token from memory
     */
    remove() {
        accessToken = null;
        if (_resolve) {
            _resolve(null);
            _resolve = null;
        }
        resetTokenReadyPromise();
    },

    /**
     * Check if access token exists
     * @returns {boolean}
     */
    hasToken() {
        return accessToken !== null;
    },

    /**
     * Clear all tokens (for logout)
     */
    clear() {
        accessToken = null;
        if (_resolve) {
            _resolve(null);
            _resolve = null;
        }
        resetTokenReadyPromise();
    },
};

export default tokenStorage;
